import React from 'react';
import { CustomPicker } from 'react-color';
import { Saturation, Hue } from 'react-color/lib/components/common'
import Card from '@material-ui/core/Card';

const size = 128;

const styles = {
    hue: {
        height: 18,
        position: 'relative',
        marginBottom: 10,
        width: size
    },
    sat: {
        position: 'relative',
        height: size,
        width: size
    },
    huePicker : {
        display: 'inline-block',
        //borderStyle: 'solid',
        //borderWidth: '1px',
        padding: '4px',
        borderRadius: '4px',
        //borderColor: '#757575'
    },
    huePointer: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, 0px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
    },
    satPointer: {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        transform: 'translate(-9px, -9px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
    }

};


class ColourPickerControl extends React.Component {
    
    render() {
    
        return (

            <Card style={{...styles.huePicker,...this.props.style}}>
                <div>
                    <div style={ styles.hue }>
                        <Hue {...this.props} onChange={ this.props.onChange }
                                            pointer={() => { return (<div style={ styles.huePointer } />)}}/>
                    </div>
                    <div style={styles.sat }>
                        <Saturation {...this.props} style={{ input: styles.input }}
                                            pointer={() => { return (<div style={ styles.satPointer } />)}} />
                    </div>
                </div>
            </Card>
        )
    }
}

export default CustomPicker(ColourPickerControl);